module.exports = __webpack_public_path__ + "assets/img/8f2023bbdf9cfc5975790690a97f3520.png";